package com.routexk.quiz.ui.components.widgets

import androidx.compose.runtime.Composable
import com.routexk.quiz.ui.theme.AppColors
import com.routexk.quiz.ui.theme.toRgbString
import com.routexk.quiz.ui.theme.withAlpha
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.animation.toAnimation
import org.jetbrains.compose.web.css.*

val SpinKeyframes = Keyframes {
    from {
        Modifier.styleModifier { property("transform", "rotate(0deg)") }
    }
    to {
        Modifier.styleModifier { property("transform", "rotate(360deg)") }
    }
}

@Composable
fun LoadingSpinner(
    modifier: Modifier = Modifier,
    size: CSSLengthOrPercentageNumericValue = 40.px,
    text: String? = null
) {
    Box(
        modifier = modifier.fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            modifier = Modifier.gap(16.px)
        ) {
            Box(
                modifier = Modifier
                    .width(size)
                    .height(size)
                    .border(
                        width = 3.px,
                        style = LineStyle.Solid,
                        color = AppColors.Primary.withAlpha(0.3f)
                    )
                    .styleModifier {
                        property("border-top-color", AppColors.Primary.toRgbString())
                    }
                    .borderRadius(50.percent)
                    .animation(
                        SpinKeyframes.toAnimation(
                            duration = 1.s,
                            timingFunction = AnimationTimingFunction.Linear
                        )
                    )
                    .styleModifier {
                        property("animation-iteration-count", "infinite")
                    }
            )

            text?.let {
                SpanText(
                    text = it,
                    modifier = Modifier
                        .color(AppColors.Primary)
                        .fontSize(14.px)
                )
            }
        }
    }
}

@Composable
fun InlineSpinner(
    modifier: Modifier = Modifier,
    size: CSSLengthOrPercentageNumericValue = 20.px
) {
    Box(
        modifier = modifier
            .width(size)
            .height(size)
            .border(
                width = 2.px,
                style = LineStyle.Solid,
                color = AppColors.Primary.withAlpha(0.3f)
            )
            .styleModifier {
                property("border-top-color", AppColors.Primary.toRgbString())
            }
            .borderRadius(50.percent)
            .animation(
                SpinKeyframes.toAnimation(
                    duration = 0.8.s,
                    timingFunction = AnimationTimingFunction.Linear
                )
            )
            .styleModifier {
                property("animation-iteration-count", "infinite")
            }
    )
}
